/* eslint-disable */

// Override Settings
window.boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    showLoading: false,
    // productAvailable: false,
    // variantAvailable: false,
    // productAndVariantAvailable: false,
    loadProductFirst: true,
    separateRefineByFromFilter: true,
    activeFilterScrollbarPC: false,
    filterTreeHorizontalStyle: 'style3',
    filterTreeMobileStyle: 'style1',
    isShortenUrlParam: true,
    urlScheme: 2,
    breakpointMobile: '1000',
    removePriceDecimal: false,
    shortenUrlParamList: [
      'pf_t_style:style',
      'pf_opt_color:color',
      'pf_t_print:print',
      'pf_opt_size:size',
      'pf_t_neckline:neckline',
      'pf_p_price:price',
      'pf_v_brand:brand'
    ],
    sortingList: [
      'manual',
      'title-ascending',
      'title-descending',
      'price-ascending',
      'price-descending',
      'published-descending'
    ],
    customSortingList: ''
  },
  label: {
    'sorting_manual': 'Featured',
    'sorting_title-ascending': 'Name: A-Z',
    'sorting_title-descending': 'Name: Z-A',
    'sorting_price-ascending': 'Price: Low to High',
    'sorting_price-descending': 'Price: High to Low',
    'sorting_published-descending': 'Newest'
  },
  custom: {
    productTileImagesType: boostPFSThemeConfig.custom.productTileImagesType // gallery or hover
  }
};

(function() {
  // Custom Data
  let productIndex = 0
  const currencyActive = window.theme.shopCurrency
  const productData = {
    activeColor: '',
    firstVariant: {},
    isStandardProduct: false,
    inventory: 0,
    priceVaries: false,
    onSale: false,
    soldOut: false,
    url: ''
  }
  let imageWidth = '450'
  let imageHeight = '610'

  // Inject yaaa!
  BoostPFS.inject(globalThis)

  /**
   * Helpers
   */
  function trimSizeName(name) {
    name = name.replace('AU', '');
    name = name.replace('US', '');
    name = name.replace('iPhone', '');
    name = name.replace('SHOE', '');
    name = name.replace('One Size', 'ONE SIZE');
    name = name.replace('ONE SIZE', 'ONE SIZE');
    return name.trim()
  }

  const preloadImage = (url) => {
    const image = new Image()
    image.src = url
  }

  /**
   * Prepare Shopify Data
   */
  function prepareShopifyData(data) {
    // Determine if it's a standard product
    productData.isStandardProduct = false
    data.variants.some(v => {
      if (v && typeof firstColor !== 'undefined') {
        if (v.option_color !== firstColor) {
          productData.isStandardProduct = true
        }
      }
    })

    // Get First Variant (selected_or_first_available_variant)
    productData.firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') productData.firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          productData.firstVariant = data['variants'][i];
          break;
        }
      }
    }

    // product.price_varies
    productData.priceVaries = data.variants.some((v) => v.price !== data.variants[0].price)

    // Inventory Information
    productData.inventory = 0
    data.variants.forEach((v) => {
      productData.inventory += v.inventory_quantity
    })

    productData.activeColor = ''
    const colorOption = data.options_with_values.filter((opt) => opt.name === 'color')
    if (colorOption.length) {
      productData.activeColor = colorOption[0].values[0].title
    }

    productData.onSale = data.compare_at_price_min > data.price_min
    productData.soldOut = !data.available

    //console.log(Utils.getProductMetafield(data, 'accentuate', 'additional_sizes'))

    return data;
  }

  /**
   * Product Tile
   */
  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    data = prepareShopifyData(data);

    //console.log(data)

    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Images
    itemHtml = buildImages(data, itemHtml)
    // Stock Badges
    itemHtml = buildBadge(data, itemHtml)
    // Quick Add
    itemHtml = buildQuickAdd(data, itemHtml)
    // Wishlist
    itemHtml = itemHtml.replace(/{{wishlistMarkup}}/g, buildWishlist(data))
    // Pricing
    itemHtml = buildPricing(data, itemHtml)
    // Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, `<a href="/collections/${Utils.slugify(data.vendor)}">${data.vendor}</a>`)
    // Build Misc (Classes, Attributes)
    itemHtml = buildMisc(data, itemHtml)

    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
    //itemHtml = itemHtml.replace(/{{selectedVariant}}/g, '')
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false))

    // Loop Returns
    if (data.handle === 'e-gift-voucher') {
      itemHtml = itemHtml.replace(/{{loopReturnHideClass}}/g, ' product-tile__loop-return-hide')
    } else {
      itemHtml = itemHtml.replace(/{{loopReturnHideClass}}/g, '')
    }

    productIndex++;
    return itemHtml;
  }

  function buildImages(data, itemHtml) {
    const imagePlaceholder = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3E%3C/svg%3E`;
    let firstImage = ''
    let hoverImage = ''
    let firstImageSrc = ''
    let hoverImageSrc = ''

    let images = data.images_info
    let imageAlt = ''

    // Metafield collection image override
    let itemThumbOverrideCollections = Utils.getProductMetafield(data, 'accentuate', 'collection_handle')
    let itemThumbOverrideUrls = Utils.getProductMetafield(data, 'accentuate', 'collection_image')
    let itemThumbOverrideUrl = null
    if (itemThumbOverrideCollections !== null && itemThumbOverrideUrls !== null) {
      itemThumbOverrideUrl = getCollectionImageOverride(JSON.parse(itemThumbOverrideUrls), JSON.parse(itemThumbOverrideCollections))
    }

    if (Globals.queryParams.page == 1 && data.images_info.length) {
      data.images_info[0].src = window.collectionImages[data.handle] || data.images_info[0].src
      data.images_info[0].src = data.images_info[0].src.replace(`_${imageWidth}x${imageHeight}`, '')
    }

    if (boostPFSFilterConfig.custom.productTileImagesType === 'gallery') {
      const isTest = document.querySelector('[data-plp-hover-enable]')
      let hoverImage = ''
      // Images
      var itemImages = ''
      if (itemThumbOverrideUrl !== null) {
        let itemImageHtml = ''
        // lazy load 2nd row of products and beyond
        if (productIndex > 3) {
          itemImageHtml = `src="${imagePlaceholder}" data-src="${itemThumbOverrideUrl}"`
        } else {
          itemImageHtml = `src="${itemThumbOverrideUrl}"`
        }
        if (isTest && images.length > 1) {
          const itemImageHover = images[1].src.includes('&options=') ? images[1].src : Utils.optimizeImage(images[1].src, `${imageWidth}x${imageHeight}`)
          hoverImage = `<img src="${imagePlaceholder}" data-src="${itemImageHover}" class="product-tile__image product-tile__image--hover" alt="${data.title}" height="${imageHeight}" width="${imageWidth}" />`
        }
        itemImages += `
          <div class="swiper-slide">
            <a href="${Utils.buildProductItemUrl(data, false)}" class="product-tile__image-link">
              <figure class="product-tile__image-holder">
                <img ${itemImageHtml} class="product-tile__image" alt="${data.title}" />${hoverImage}
              </figure>
            </a>
          </div>
        `
        // Remove duplicate
        images = images.filter(item => {
          return !item.src.includes(itemThumbOverrideUrl.split('?')[0])
        })
      }
      images.forEach((img, i) => {
        const itemImage = img.src.includes('&options=') ? img.src : Utils.optimizeImage(img.src, `${imageWidth}x${imageHeight}`)
        let itemImageHtml = ''
        // lazy load 2nd row of products and beyond
        if (productIndex < 4 && i < 1 && !itemThumbOverrideUrl) {
          itemImageHtml = `src="${itemImage}"`
        } else {
          itemImageHtml = `src="${imagePlaceholder}" data-src="${itemImage}"`
        }
        if (hoverImage === '' && isTest && images.length > 1) {
          const itemImageHover = images[1].src.includes('&options=') ? images[1].src : Utils.optimizeImage(images[1].src, `${imageWidth}x${imageHeight}`)
          hoverImage = `<img src="${imagePlaceholder}" data-src="${itemImageHover}" class="product-tile__image product-tile__image--hover" alt="${data.title}" height="${imageHeight}" width="${imageWidth}" />`
        }
        itemImages += `
          <div class="swiper-slide">
            <a href="${Utils.buildProductItemUrl(data, false)}" class="product-tile__image-link">
              <figure class="product-tile__image-holder">
                <img ${itemImageHtml} class="product-tile__image" alt="${data.title}" height="${imageHeight}" width="${imageWidth}" />${hoverImage}
              </figure>
            </a>
          </div>
        `
      })
      itemHtml = itemHtml.replace(/{{itemImages}}/g, `
        <div class="product-tile__carousel" data-product-tile-carousel>
          <div class="swiper-wrapper">
            ${itemImages}
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      `)
    } else {
      if (images[0] !== undefined) {
        imageAlt = images[0].alt ? images[0].alt : data.title
        firstImageSrc = itemThumbOverrideUrl !== null ? itemThumbOverrideUrl : Utils.optimizeImage(images[0].src, `${imageWidth}x${imageHeight}`)

        // lazy load 2nd row of products and beyond
        if (productIndex > 3) {
          firstImage = `<img data-src="${firstImageSrc}" class="product-tile__image lazy" alt="${imageAlt}" width="${imageWidth}" height="${imageHeight}" data-featured-image />`
        } else {
          firstImage = `<img src="${firstImageSrc}" class="product-tile__image" alt="${imageAlt}" width="${imageWidth}" height="${imageHeight}" data-featured-image />`
        }
      }

      if (images[1] !== undefined) {
        imageAlt = images[1].alt ? images[1].alt : data.title
        hoverImageSrc = itemThumbOverrideUrl !== null ? Utils.optimizeImage(images[0].src, `${imageWidth}x${imageHeight}`) : Utils.optimizeImage(images[1].src, `${imageWidth}x${imageHeight}`)

        // lazy load all hover images
        hoverImage = `<img data-src="${hoverImageSrc}" class="product-tile__image product-tile__image--hover lazy" alt="${imageAlt}" width="${imageWidth}" height="${imageHeight}" data-hover-image />`
      }

      itemHtml = itemHtml.replace(/{{itemImages}}/g, `
        <div class="product-tile__images">
          <a href="${Utils.buildProductItemUrl(data, false)}" class="product-tile__image-link">
            <figure class="product-tile__image-holder">
              ${firstImage}${hoverImage}
            </figure>
          </a>
        </div>`);
    }

    return itemHtml;
  }

  function getCollectionImageOverride(itemThumbOverrideUrls, itemThumbOverrideCollections) {
    let itemThumbOverrideUrl = null
    const imageWidth = '450'
    if (itemThumbOverrideCollections !== null && itemThumbOverrideUrls !== null) {
      itemThumbOverrideCollections.forEach((collectionHandle, index) => {
        if (window.boostPFSThemeConfig.custom.collectionHandle && window.boostPFSThemeConfig.custom.collectionHandle == collectionHandle) {
          let fileObj = itemThumbOverrideUrls[index]
          // If this is an array there are multiple repeatable fields
          // and we need to get the first image
          if (Array.isArray(fileObj)) {
            fileObj = fileObj[0]
          }
          itemThumbOverrideUrl = fileObj.cloudinary_src + `w_${imageWidth},q_80,e_sharpen:100`
        }
      })
    }

    return itemThumbOverrideUrl;
  }

  function buildBadge(data, itemHtml) {
    const badgeData = getBadge(data.collections, productData.inventory, data.tags, data.vendor)

    itemHtml = itemHtml.replace(/{{productStockBadge}}/g, badgeData.productStockBadge)
    itemHtml = itemHtml.replace(/{{productStockStatus}}/g, badgeData.productStockStatus)

    // Product Promotions
    itemHtml = itemHtml.replace(/{{itemCollectionHandles}}/g, badgeData.itemCollectionHandles)
    itemHtml = itemHtml.replace(/{{cleanTags}}/g, badgeData.cleanTags)

    return itemHtml
  }

  function getBadge(collections, inventory, tags, vendor) {
    const itemCollectionHandles = collections.map(i => i.handle).join(',');
    let productStockStatus = 'out-of-stock'
    let productStockBadgeClass = ' hidden'
    let productStockBadgeText = ''

    // Stock status badges
    if (inventory >= 20) {
      productStockStatus = 'in-stock'
    } else if (inventory > 0) {
      productStockStatus = 'limited-stock'
      productStockBadgeText = 'Low Stock'
      productStockBadgeClass = ' product-tile__stock-badge--limited-stock'
    }

    // Product Tile Badges badges
    let cleanTags = tags.map(tag => tag.toLowerCase())
    const productVendor = vendor
    if (productData.inventory < 20 && productData.inventory > 0) {
      productStockBadgeText = 'Low Stock'
      productStockBadgeClass = ' product-tile__stock-badge--limited-stock'
    } else if (cleanTags.includes('princess polly petite')) {
      productStockBadgeText = 'Petite'
      productStockBadgeClass = ' product-tile__stock-badge--petite'
    } else if (cleanTags.includes('princess polly curve')) {
      productStockBadgeText = 'Curve'
      productStockBadgeClass = ' product-tile__stock-badge--curve'
    } else if (cleanTags.includes('princess polly tall')) {
      productStockBadgeText = 'Tall'
      productStockBadgeClass = ' product-tile__stock-badge--tall'
    } else if (itemCollectionHandles.includes('vegan-edit')) {
      productStockBadgeText = 'Vegan'
      productStockBadgeClass = ' product-tile__stock-badge--vegan'
    }

    const badgeArr = tags.filter((tag) => tag.includes('Badge:') || tag.includes('badge:'))

    if (badgeArr.length) {
      const badgeText = badgeArr[0].split(':').pop()
      productStockBadgeText = badgeText
      productStockBadgeClass = ` product-tile__stock-badge--${Utils.slugify(badgeText)}`
    }

    let productStockBadge = `
      <div class="product-tile__stock-badge${productStockBadgeClass}" data-product-tile-stock>
        <span>${productStockBadgeText}</span>
      </div>
    `.trim()

    const badgeData = {
      productStockBadge: productStockBadge,
      productStockStatus: productStockStatus,
      itemCollectionHandles: itemCollectionHandles,
      cleanTags: cleanTags
    }

    return badgeData;
  }

  // Quick Add Sizes from Boost Data
  function buildQuickAdd(data, itemHtml) {
    let items = ''
    let variantSizes = []
    let variantAvailable = []

    data.variants.forEach((v) => {
      if (v.option_size && !variantSizes.includes(v.option_size)) {
        let name = v.option_size
        let disabled = v.available ? '' : ' disabled'
        const notValid = !v.available && 'hiddenOOSSizes' in window && Array.isArray(window.hiddenOOSSizes) && window.hiddenOOSSizes.indexOf(name.toLowerCase()) >= 0

        if(!notValid) {
          name = trimSizeName(name)
          variantAvailable.push(v.available)
          variantSizes.push(v.option_size)

          items += `
            <li class="product-tile-size__item${disabled}">
              <button
                class="product-tile-size__button"
                type="button"
                data-product-tile-size
                data-product-tile-variant-id="${v.id}"
                data-product-tile-variant-available="${v.available}"
              >${name}</button>
            </li>
          `.trim()
        }
      }
    })

    // Quick Add - exclude if all sizes are the same
    let hideSize = false
    if (variantSizes.every((val, i, arr) => val === arr[0]) && variantSizes.length > 1) {
      hideSize = true
    }

    // All Sizes Unavailable
    let itemHideSizes = variantAvailable[0] === false && variantAvailable.every((val, i, arr) => val === arr[0]) ? ' hidden-size-mobile' : ''

    let itemQuickAddLink = items === '' || hideSize === true ? '' : `
      <button type="button" class="product-tile__quick" data-product-tile-quickadd data-product-url>
        <span class="product-tile__quick-icon"></span>
        <span class="product-tile__quick-text">Quick Add</span>
        <span class="product-tile__quick-sold-out">Sold Out</span>
      </button>
    `.trim()

    let itemQuickAddMessage = variantSizes.length <= 1 ? 'Add to my bag' : 'Select a Size'
    let itemQuickAdd = items === '' || hideSize === true ? '' : `
      <div class="product-tile-size" data-product-tile-quickadd-container>
        <p class="product-tile-size__title">
          <span data-product-tile-size-message>${itemQuickAddMessage}</span>
        </p>
        <ul class="product-tile-size__list" data-product-tile-quickadd-list>${items}</ul>
      </div>
    `.trim()

    itemHtml = itemHtml.replace(/{{itemColor}}/g, productData.activeColor)
    itemHtml = itemHtml.replace(/{{itemHideSizes}}/g, itemHideSizes)
    itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, itemQuickAdd)
    itemHtml = itemHtml.replace(/{{itemQuickAddLink}}/g, itemQuickAddLink)

    return itemHtml;
  }

  function buildWishlist(data) {
    const wishlistProductId = JSON.stringify(parseInt(data.id))
    let wishlistMarkup = `
      <button
        class="swym-button swym-add-to-wishlist-view-product product_${data.id}"
        tabindex="0"
        data-with-epi="true"
        data-swym-wishlist-button
        data-swaction="addToWishlist"
        data-product-id="${wishlistProductId}"
        data-variant-id="${productData.firstVariant.id}"
        data-product-url="${window.boostPFSThemeConfig.custom.shopUrl}${Utils.buildProductItemUrl(data, false)}"
      >
        <span class="icon icon--wishlist"></span>
      </button>
      <button class="wish-button" data-product-handle="${data.handle}" aria-label="open wishlist modal">
        
      </button>
    `.trim()

    return wishlistMarkup;
  }

  function buildPricing(data, itemHtml) {
    let itemPriceHtml = ''
    let itemSalePriceHtml = ''
    let salePriceClass = 'hidden'
    let salePriceHtml = ''
    let itemPricesVary = ''
    let itemSaleClass = productData.onSale ? ' product-tile__meta--sale' : ''

    if (productData.isStandardProduct) {
      let hasCompareAt = productData.firstVariant.compare_at_price !== null

      itemPriceHtml += Utils.formatMoney(productData.firstVariant.price)

      if (hasCompareAt && productData.firstVariant.compare_at_price !== productData.firstVariant.price) {
        salePriceClass = ''
        itemSalePriceHtml += `<s class="product-tile__price-sale" data-product-price-sale>${Utils.formatMoney(productData.firstVariant.compare_at_price)}</s> `

        // show discounted %
        salePriceHtml += Math.round(100 - ((parseFloat(productData.firstVariant.price) / parseFloat(productData.firstVariant.compare_at_price)).toFixed(4)) * 100) + '% off'
        itemHtml = itemHtml.replace(/{{onSaleAttr}}/g, 'true')
      } else {
        itemHtml = itemHtml.replace(/{{onSaleAttr}}/g, 'false')
      }

      let variantPrices = data.variants.map(variant => variant.price);
      //console.log('POLLY-standard', variantPrices)
      let maxVariantPrice = Math.max(...variantPrices);
      let minVariantPrice = Math.min(...variantPrices);
      if (data.product_type !== 'Gift Card' && data.product_type !== 'Donation' && maxVariantPrice !== minVariantPrice) {
        //let maxDiscount = Math.floor(Math.abs(100 * ((minVariantPrice - maxVariantPrice) / maxVariantPrice)))
        itemPricesVary += `
          <em class="product-prices-vary" data-product-prices-vary="collection">
            Select sizes on sale
          </em>
        `
      }

      const noCompareAtPrices = (
        (data.compare_at_price_max === 0 || data.compare_at_price_max === null) &&
        (data.compare_at_price_min === 0 || data.compare_at_price_min === null)
      )

      if ((productData.priceVaries && noCompareAtPrices) || (maxVariantPrice !== minVariantPrice)) {
        itemPriceHtml = `${Utils.formatMoney(minVariantPrice)}<span> - </span><span>${Utils.formatMoney(maxVariantPrice)}</span>`
        itemSaleClass = ''
        itemSalePriceHtml = ''
      }

      itemHtml = itemHtml.replace(/{{itemPricesVary}}/g, itemPricesVary)
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, () => { return itemPriceHtml })
      itemHtml = itemHtml.replace(/{{itemSalePrice}}/g, () => { return itemSalePriceHtml })
      itemHtml = itemHtml.replace(/{{rawPrice}}/g, productData.firstVariant.price)
      itemHtml = itemHtml.replace(/{{salePriceClass}}/g, salePriceClass)
      itemHtml = itemHtml.replace(/{{salePrice}}/g, salePriceHtml)
    } else {
      let compareAtPriceAmount = data.compare_at_price_min
      let priceAmount = data.price_min

      itemPriceHtml += Utils.formatMoney(priceAmount)

      if (productData.onSale) {
        salePriceClass = ''
        itemSalePriceHtml += `<s class="product-tile__price-sale" data-product-price-sale>${Utils.formatMoney(compareAtPriceAmount)}</s>`

        // show discounted %
        salePriceHtml += Math.round(100 - ((parseFloat(data.price_min) / parseFloat(data.compare_at_price_min)).toFixed(4)) * 100) + '% off'
        itemHtml = itemHtml.replace(/{{onSaleAttr}}/g, 'true')
      } else {
        itemHtml = itemHtml.replace(/{{onSaleAttr}}/g, 'false')
      }

      const excludedProductTypes = ['Gift Card', 'Gift Cards', 'Donation']
      let variantPrices = data.variants.map(variant => variant.price);
      // console.log('POLLY-data', variantPrices)
      let maxVariantPrice = Math.max(...variantPrices);
      let minVariantPrice = Math.min(...variantPrices);
      if (!excludedProductTypes.includes(data.product_type) && maxVariantPrice !== minVariantPrice) {
        //let maxDiscount = Math.floor(Math.abs(100 * ((minVariantPrice - maxVariantPrice) / maxVariantPrice)))
        itemPricesVary += `
          <em class="product-prices-vary" data-product-prices-vary="collection">
            Select sizes on sale
          </em>
        `
      }

      const noCompareAtPrices = (
        (data.compare_at_price_max === 0 || data.compare_at_price_max === null) &&
        (data.compare_at_price_min === 0 || data.compare_at_price_min === null)
      )

      if ((productData.priceVaries && noCompareAtPrices) || (maxVariantPrice !== minVariantPrice)) {
        itemPriceHtml = `${Utils.formatMoney(minVariantPrice)}<span> - </span><span>${Utils.formatMoney(maxVariantPrice)}</span>`
        itemSaleClass = ''
        itemSalePriceHtml = ''
      }

      itemHtml = itemHtml.replace(/{{itemPricesVary}}/g, itemPricesVary)
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, () => { return itemPriceHtml })
      itemHtml = itemHtml.replace(/{{itemSalePrice}}/g, () => { return itemSalePriceHtml })
      itemHtml = itemHtml.replace(/{{rawPrice}}/g, priceAmount * 100)
      itemHtml = itemHtml.replace(/{{salePriceClass}}/g, salePriceClass)
      itemHtml = itemHtml.replace(/{{salePrice}}/g, salePriceHtml)
    }

    itemHtml = itemHtml.replace(/{{currencyActive}}/g, currencyActive)
    itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass)

    return itemHtml;
  }

  function buildMisc(data, itemHtml) {
    const swatchTag = data.tags.find((tag) => tag.startsWith('swatches-'))
    let hasMetaProductsClass = ''
    let metaProductsDataAttr = ''
    if (swatchTag) {
      hasMetaProductsClass = ' has--meta-swatches'
      metaProductsDataAttr = 'data-swatch-products=\'' + swatchTag + '\''
    } else {
      const additionalSizes = Utils.getProductMetafield(data, 'accentuate', 'additional_sizes')
      if (additionalSizes && additionalSizes !== data.handle) {
        metaProductsDataAttr = 'data-additional-sizes-handle=\'' + additionalSizes + '\''
      }
    }

    const productReviewAverage = Utils.getProductMetafield(data, 'yotpo', 'reviews_average') || ''

    const cleanData = data
    cleanData['collections'] = []
    cleanData['body_html'] = ''
    cleanData['content'] = ''
    cleanData['description'] = []
    cleanData['tags'] = []

    let noColorProductDataAttr = ''
    if (!productData.activeColor && data['variants'].length === 1) {
      noColorProductDataAttr = 'data-product-data=\'' + JSON.stringify(cleanData).replace(/\'/g, "&apos;") + '\''
    }

    // Hide empty brands
    const vendorSlug = Utils.slugify(data.vendor)
    const shopNameSlug = Utils.slugify(window.theme.shopName).replace('-', '')
    let vendorClass = ''
    if (vendorSlug === 'blank' || vendorSlug === shopNameSlug || vendorSlug === shopNameSlug + 'dev' || data.vendor === 'Princess Polly') {
      vendorClass = 'hidden'
    }

    itemHtml = itemHtml.replace(/{{itemVendorClass}}/g, vendorClass)
    itemHtml = itemHtml.replace(/{{noColorProductDataAttr}}/g, noColorProductDataAttr)
    itemHtml = itemHtml.replace(/{{hasMetaProductsClass}}/g, hasMetaProductsClass)
    itemHtml = itemHtml.replace(/{{metaProductsDataAttr}}/g, metaProductsDataAttr)
    itemHtml = itemHtml.replace(/{{productReviewAverage}}/g, productReviewAverage)

    return itemHtml;
  }

  ProductList.prototype.beforeRender = function() {
    // Get the images rendered by shopify intially because the versions can vary
    // in boost. This eliminates a flicker while loading
    window.collectionImages = {}
    document.querySelectorAll('[data-product-tile-shopify]').forEach(tile => {
      const image = tile.querySelector('.product-tile__image')
      window.collectionImages[tile.dataset.productTile] = image.src || image.dataset.src
    })
  }

  function buildEmptyCollectionPage() {
    const desktopImage = window.theme.baseCurrency === 'AUD'? 'https://cdn.shopify.com/s/files/1/0076/6040/4818/files/empty_collection_banner_desktop' : 'https://cdn.shopify.com/s/files/1/0061/8627/0804/files/empty_collection_banner_desktop'
    const mobileImage = window.theme.baseCurrency === 'AUD'? 'https://cdn.shopify.com/s/files/1/0076/6040/4818/files/empty_collection_banner_mobile' : 'https://cdn.shopify.com/s/files/1/0061/8627/0804/files/empty_collection_banner_mobile'
    const emptyCollectionTemplate = `
      <section class="empty-collection">
        <div class="empty-collection__wrap">
          <a href="{{ url }}" class="empty-collection__link">
            <picture class="empty-collection__picture empty-collection__picture--no-mobile">
              <source srcset="${desktopImage}_984x.progressive.jpg 1x,
              ${desktopImage}_984x@2x.progressive.jpg 2x" media="(min-width: 768px)">
              <img
                src="${desktopImage}_375x.progressive.jpg?v=1687214822"
                alt="Empty Collection"
                height="711"
                width="984"
              >
            </picture>

            <picture class="empty-collection__picture empty-collection__picture--mobile">
              <source srcset="${mobileImage}_375x.progressive.jpg" media="(min-width: 768px)">
              <source srcset="${mobileImage}_767x.progressive.jpg 1x, ${mobileImage}_767x@2x.progressive.jpg 2x" media="(min-width: 576px)">
              <source srcset="${mobileImage}_576x.progressive.jpg 1x, ${mobileImage}_576x@2x.progressive.jpg 2x" media="(min-width: 414px)">
              <source srcset="${mobileImage}_414x.progressive.jpg 1x, ${mobileImage}_414x@2x.progressive.jpg 2x" media="(min-width: 375px)">
              <source srcset="${mobileImage}_375x.progressive.jpg 1x, ${mobileImage}_375x@2x.progressive.jpg 2x">
              <img
                src="${mobileImage}_375x.progressive.jpg"
                alt="Empty Collection"
                height="852"
                width="563"
              >
            </picture>
          </a>
        </div>
        <div class="nosto_element" id="nosto-empty-collection1"></div>
        <div class="nosto_element" id="nosto-empty-collection2"></div>
      </section>
    `

    try {
      const totalProductCount = window.boostPFS.filter.data.total_product
      if (totalProductCount === 0) {
        const collectionContainer = document.querySelector('.collection')
        if (collectionContainer) {
          collectionContainer.innerHTML = emptyCollectionTemplate
          if (window.nostojs) {
            window.nostojs((api) => {
              api.loadRecommendations()
            })
          }

          const footer = document.querySelector('.footer')
          if (footer) {
            footer.classList.add('empty-collection')
          }
        }
      }
    }
    catch(e) {
      console.log(e)
    }
  }
  ProductList.prototype.afterRender = function() {
    window.lazyLoadInstance.update()
    window.collectionSwipers = {}
    buildEmptyCollectionPage()

    // observe tiles in view, then load swatches and additional sizes
    const tiles = document.querySelectorAll('.collection-items [data-product-tile]')
    tiles.forEach((product) => {
      let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            buildSwiper(product)
            renderSwatches(product)
            fetchAdditionalSizes(product)
            observer.unobserve(entry.target)
          }
        })
      })
      observer.observe(product)
    })

    // wishlist is ready to be initialized
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  function buildSwiper(tile) {
    let swiperOptions = {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true, // Hopefully swiper fixes this working with lazy.checkInView
      preloadImages: false,
      threshold: 8,
      lazy: {
        checkInView: true,
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        elementClass: 'product-tile__image'
      }
    }

    // Carousels
    window.collectionSwipers[tile.dataset.productTile] = new Swiper(`[data-product-tile="${tile.dataset.productTile}"] [data-product-tile-carousel]`, swiperOptions);
    // console.log('[COLLECTION]', 'buildSwiper', `[data-product-tile="${tile.dataset.productTile}"] [data-product-tile-carousel]`)
  }

  /**
   * Swatches - tile in view
   */
  function renderSwatches(tile) {
    const productHandle = tile.dataset.productTile
    const activeColor = tile.dataset.productTileActiveColor
    const swatchContainer = tile.querySelector('[data-product-tile-swatches]')

    fetch(`${window.Shopify.routes.root}products/${productHandle}?view=swatches.json`)
      .then((response) => response.json())
      .then((data) => {
        let swatchList = ''
        let activeClass = ''
        if (data.swatch_products.length > 0) {
          data.swatch_products.forEach((product) => {
            if (product.available) {
              if (product.handle === productHandle) {
                activeClass = ' swatch--active'
              } else {
                activeClass = ''
              }

              let imageOverride = getCollectionImageOverride(product.collection_image, product.collection_image_handle)
              let featuredImage = imageOverride !== null ? imageOverride : product.featured_image
              let hoverImage = imageOverride !== null ? product.featured_image : product.hover_image

              if (product.swatch_color) {
                swatchList += `
                  <a
                    href="${product.url}"
                    data-swatch
                    data-handle="${product.handle}"
                    data-product-id="${product.id}"
                    data-featured-image="${featuredImage}"
                    data-hover-image="${hoverImage}"
                    title="${activeColor}"
                    class="swatch${activeClass}"
                    style="background-color: ${product.swatch_color};"></a>
                `.trim()
              } else {
                swatchList += `
                  <a
                    href="${product.url}"
                    data-swatch
                    data-handle="${product.handle}"
                    data-featured-image="${featuredImage}"
                    data-hover-image="${hoverImage}"
                    title="${activeColor}"
                    class="swatch${activeClass}"
                    style="background-image: url('${product.swatch_image}');"></a>
                `.trim()
              }
            }
          })
        }

        if (swatchList !== '') {
          swatchContainer.innerHTML = swatchList
        }
      })
  }

  function swatchEvents() {
    jQuery('.collection-items').on('click', '[data-swatch]', (e) => {
      e.preventDefault()
      const $swatch = jQuery(e.currentTarget)
      if ($swatch.is('swatch--active') || $swatch.is(':only-child')) {
        return false;
      }

      $swatch.addClass('swatch--active').siblings().removeClass('swatch--active')
      const $tile = $swatch.closest('[data-product-tile]')
      const handle = $swatch.data('handle')

      preloadImage($swatch.data('featured-image'))
      preloadImage($swatch.data('hover-image'))

      fetch(`${window.Shopify.routes.root}products/${handle}?view=meta.json`)
        .then((response) => response.json())
        .then((response) => {
          console.log(response)
          // Image Updates
          if (boostPFSFilterConfig.custom.productTileImagesType === 'gallery') {
            const swiper = window.collectionSwipers[$tile.data('product-tile')]
            const isTest = document.querySelector('[data-plp-hover-enable]')
            let hoverImage = ''
            swiper.removeAllSlides()
            if (isTest && response.product.images.length > 1) {
              const itemImageHover = response.product.images[1].includes('&options=') ? response.product.images[1] : Utils.optimizeImage(response.product.images[1], `${imageWidth}x${imageHeight}`)
              hoverImage = `<img src="${itemImageHover}" class="product-tile__image product-tile__image--hover" alt="${response.title}" height="${imageHeight}" width="${imageWidth}" />`
            }
            response.product.images.forEach((image, index) => {
              const itemImage = Utils.optimizeImage(image, `${imageWidth}x${imageHeight}`)
              let itemImageHtml = `src="${itemImage}"`
              if (index === 0) {
                const imageOverride = getCollectionImageOverride(response.override_image, response.override_handle)
                if (imageOverride) {
                  itemImageHtml = `src="${imageOverride}"`
                }
              }
              swiper.appendSlide(`
                <div class="swiper-slide">
                  <a href="${window.boostPFSThemeConfig.custom.shopUrl}${response.url}" class="product-tile__image-link">
                    <figure class="product-tile__image-holder">
                      <img ${itemImageHtml} class="product-tile__image" alt="${response.title}" height="${imageHeight}" width="${imageWidth}" />${hoverImage}
                    </figure>
                  </a>
                </div>
              `)
            })
            swiper.slideTo(1, 0)
          } else {
            $tile.find('img[data-featured-image]').attr('src', $swatch.data('featured-image'))
            $tile.find('img[data-hover-image]').attr('src', $swatch.data('hover-image'))
          }

          // Title
          $tile.find('[data-product-title]').text(response.title)

          // URLs
          $tile.find('.product-tile__image-link, .product-tile__name').attr('href', response.url)

          // Wishlist Data
          $tile.find('[data-swym-wishlist-button]')
            .attr('data-product-id', response.product.id)
            .attr('data-variant-id', response.variants[0].id)
            .attr('data-product-url', `${window.boostPFSThemeConfig.custom.shopUrl}${response.url}`)
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

          // Pricing
          const priceContainer = $tile.find('[data-product-price]')
          const saleDisplay = $tile.find('[data-product-price-sale]')
          const saleDiscount = $tile.find('[data-product-savi]')
          const saleDiscountClass = $tile.find('[data-product-sale-price]')
          const meta = $tile.find('[data-product-meta]')

          if (saleDisplay.length) {
            saleDisplay.remove()
          }

          priceContainer.html(Utils.formatMoney(response.product.price / 100.0))

          if (response.product.compare_at_price && response.product.compare_at_price > response.product.price) {
            const salePrice = `
              <s class="product-tile__price-sale" data-product-price-sale>${Utils.formatMoney(response.product.compare_at_price / 100.0)}</s>
            `;
            jQuery(salePrice).insertAfter(priceContainer)
            saleDiscount.text(Math.round(100 - ((parseFloat(response.product.price) / parseFloat(response.product.compare_at_price)).toFixed(4)) * 100) + '% off')
            saleDiscountClass.removeClass('hidden')
            meta.addClass('product-tile__meta--sale')
          } else {
            saleDiscount.empty()
            saleDiscountClass.addClass('hidden')
            meta.removeClass('product-tile__meta--sale')
          }

          // Badges
          const stockBadge = $tile.find('[data-product-tile-stock]')
          let productInventory = 0
          response.inventory.map((item) => { productInventory += item.quantity })

          const badgeData = getBadge(response.product_collections, productInventory, response.product.tags, response.product.vendor)
          stockBadge.replaceWith(badgeData.productStockBadge)
          $tile.attr('data-product-stock', badgeData.productStockStatus)

          // Promotion Message
          const promotionMessage = $tile.find('[data-product-promotion-message]')
          const collections = []
          response.product_collections.forEach((collection) => {
            collections.push(collection.handle)
          })
          promotionMessage.removeAttr('data-promotion-populated')
          promotionMessage.attr('data-price', response.product.price).trigger('datachange')
          promotionMessage.attr('data-collections', collections.toString()).trigger('datachange')
          new ProductPromotion()

          // Update Quick Add Size List
          updateSizeList($tile.get(0), response)
        })
    })
  }

  swatchEvents()

  /**
   * Quick Add Size List - swatch switch
   * 1. Regular Sizes
   * 2. Additional Sizes
   */
  function updateSizeList(tile, response) {
    const quickAddList = tile.querySelector('[data-product-tile-quickadd-list]')
    const sizeContainer = tile.querySelector('[data-product-tile-quickadd-container]')

    let variantAvailable = []
    let variantSizes = []
    let sizeList = buildSizeList(response.product, variantSizes, variantAvailable)

    // additional sizes
    if (response.additional_sizes && response.additional_sizes.handle !== response.product.handle && response.additional_sizes.available) {
      let optionsIndex = null
      response.additional_sizes.options.forEach((option, i) => {
        if (option === 'Size') optionsIndex = i + 1
      })
      let additionalSizeList = buildSizeList(response.additional_sizes, variantSizes, variantAvailable)
      const append = parseInt(trimSizeName(response.additional_sizes.variants[0]['option' + optionsIndex])) < parseInt(trimSizeName(variantSizes[0])) ? false : true

      const sizeBreak = '<li class="product-tile-size__break"><li>'
      if (append) {
        additionalSizeList = sizeBreak + additionalSizeList
        sizeList += additionalSizeList
      } else {
        additionalSizeList = additionalSizeList + sizeBreak
        sizeList = additionalSizeList + sizeList
      }
    }

    quickAddList.innerHTML = sizeList

    if (variantSizes.every((val, i, arr) => val === arr[0]) && variantSizes.length > 1) {
      sizeContainer.classList.add('hidden')
    } else {
      sizeContainer.classList.remove('hidden')
    }
    if (variantAvailable[0] === false && variantAvailable.every((val, i, arr) => val === arr[0])) {
      tile.classList.add('hidden-size-mobile')
    } else {
      tile.classList.remove('hidden-size-mobile')
    }
  }

  function buildSizeList(product, variantSizes=[], variantAvailable=[]) {
    let quickaddSizeTemplate = ''
    var optionsIndex = null
    product.options.forEach((option, i) => {
      if (option === 'Size') optionsIndex = i + 1
    })
    if (optionsIndex === null) return;
    product.variants.forEach((variant) => {
      if (!variantSizes.includes(variant['option' + optionsIndex])) {
        var name = variant['option' + optionsIndex];
        var available = variant.available;
        var disabled = available ? '' : ' disabled';
        name = trimSizeName(name)
        variantAvailable.push(variant.available)
        variantSizes.push(variant['option' + optionsIndex])
        quickaddSizeTemplate += `
          <li class="product-tile-size__item${disabled}">
            <button
              class="product-tile-size__button"
              type="button"
              data-product-tile-size
              data-product-tile-variant-id="${variant.id}"
              data-product-tile-variant-available="${available}"
            >${name}</button>
          </li>`
      }
    })

    return quickaddSizeTemplate
  }

  /**
   * Quick Add Additional Sizes - on tile in view
   */
  function fetchAdditionalSizes(tile) {
    const productHandle = tile.dataset.productTile

    const quickAddList = tile.querySelector('[data-product-tile-quickadd-list]')
    if (!quickAddList) return;

    fetch(`${window.Shopify.routes.root}products/${productHandle}?view=meta.json`)
    .then((response) => response.json())
    .then((response) => {
      renderAdditionalSizes(tile, response)
    })
  }

  function renderAdditionalSizes(tile, response) {
    const productHandle = tile.dataset.productTile
    const quickAddList = tile.querySelector('[data-product-tile-quickadd-list]')

    if (!quickAddList) return;

    const additionalSizes = quickAddList.querySelectorAll('[data-product-tile-additional-size]')
    additionalSizes.forEach((el) => {
      el.remove()
    })

    const additionalSizeProduct = response.additional_sizes
    if (additionalSizeProduct && additionalSizeProduct.handle !== productHandle && additionalSizeProduct.available) {
      let optionsIndex = null
      additionalSizeProduct.options.forEach((option, i) => {
        if (option == 'Size') {
          optionsIndex = i + 1
        }
      })

      let items = ''
      let variantSizes = []
      let variantAvailable = []

      additionalSizeProduct.variants.forEach((v) => {
        if (v[`option${optionsIndex}`] && !variantSizes.includes(v[`option${optionsIndex}`])) {
          let name = v[`option${optionsIndex}`]
          let disabled = v.available ? '' : ' disabled'
          const notValid = !v.available && 'hiddenOOSSizes' in window && Array.isArray(window.hiddenOOSSizes) && window.hiddenOOSSizes.indexOf(name.toLowerCase()) >= 0

          if(!notValid) {
            name = trimSizeName(name)
            variantAvailable.push(v.available)
            variantSizes.push(v[`option${optionsIndex}`])

            items += `
              <li class="product-tile-size__item${disabled}" data-product-tile-additional-size>
                <button
                  class="product-tile-size__button"
                  type="button"
                  data-product-tile-size
                  data-product-tile-variant-id="${v.id}"
                  data-product-tile-variant-available="${v.available}"
                >${name}</button>
              </li>
            `.trim()
          }
        }
      })

      const sizeBreak = '<li class="product-tile-size__break" data-product-tile-additional-size><li>'
      const currentLowestSize = tile.querySelector('[data-product-tile-size]')
      let append = true
      if (currentLowestSize) {
        append = parseInt(trimSizeName(additionalSizeProduct.variants[0]['option' + optionsIndex])) < parseInt(trimSizeName(currentLowestSize.textContent)) ? false : true
      }

      if (append) {
        items = sizeBreak + items
        quickAddList.innerHTML += items
      } else {
        items = items + sizeBreak
        quickAddList.innerHTML = items + quickAddList.innerHTML
      }
    }
  }

  /**
   * Quick Add Events
   */
  function quickAddEvents() {
    // Size Quick Add
    jQuery('body').on('click', '[data-product-tile-size]', function () {
      var item = jQuery(this)
      var container = item.closest('[data-product-tile]')
      var id = item.data('product-tile-variant-id')
      var available = item.data('product-tile-variant-available')
      var message = container.find('[data-product-tile-size-message]')
      var messageText = message.text()

      var data = {
        id: id,
        quantity: 1
      }

      if (available !== false) {
        message.text('Added to Bag!')
        item.addClass('active')
        container.addClass('quickadd-mobile')

        setTimeout(function () {
          window.VueMiniCart.$store.dispatch('addItem', data)
        }, 1000)

        // POLLY-1740 AB Test Start
        const test = jQuery('[data-plp-add-to-cart]')
        const sticky = jQuery('[data-collection-sticky]')
        const smsBumpMobilePopups = jQuery('.gYabaY .mini-popup-container.container-mobile, .ctfhou.yotpo-smsbump-modal__content')
        const gorgiasChatButton = jQuery('#chat-button')

        if (test.length && sticky.length && window.matchMedia('(max-width: 767px)').matches) {
          sticky.addClass('active')
          if (smsBumpMobilePopups.length) {
               smsBumpMobilePopups.addClass('collection-sticky-active')
          }
          if (gorgiasChatButton.length) {
               gorgiasChatButton.addClass('collection-sticky-active')
          }
        // POLLY-1740 AB Test End
        } else {
          setTimeout(function () {
            jQuery('html').addClass('sidebar-cart--active')
            jQuery('html').find('[data-sidebar-backdrop="cart"]').addClass('sidebar__backdrop--active')
          }, 1300)
        }

        setTimeout(function () {
          container.removeClass('quickadd-mobile')
          message.text(messageText)
        }, 1600)
      }
    })

    // POLLY-1740 AB Test Start
    jQuery('body').on('click', '[data-collection-sticky-button]', function () {
      jQuery('html').addClass('sidebar-cart--active')
      jQuery('html').find('[data-sidebar-backdrop="cart"]').addClass('sidebar__backdrop--active')
      jQuery('[data-collection-sticky]').removeClass('active')

      const smsBumpMobilePopups = jQuery('.gYabaY .mini-popup-container.container-mobile, .ctfhou.yotpo-smsbump-modal__content')
      const gorgiasChatButton = jQuery('#chat-button')
      if (smsBumpMobilePopups.length) {
           smsBumpMobilePopups.removeClass('collection-sticky-active')
      }
      if (gorgiasChatButton.length) {
           gorgiasChatButton.removeClass('collection-sticky-active')
      }
    })
    // POLLY-1740 AB Test End

    // Quick Add Display
    jQuery('body').on('click', '[data-product-tile-quickadd]', function () {
      var item = jQuery(this)
      var container = item.closest('[data-product-tile]')
      jQuery('[data-product-tile]').not(container).removeClass('quickadd')
      container.toggleClass('quickadd')
    })

    // Quick Add Display Click Outside
    jQuery('body').on('click', function (e) {
      var item = jQuery(e.target)
      if (!item.hasClass('product-tile__quick')) {
        jQuery('[data-product-tile]').removeClass('quickadd')
      }
    })
  }

  quickAddEvents()

  // Wishlist Listener
  window.SwymCallbacks = window.SwymCallbacks || []
  window.SwymCallbacks.push(function(swat) {
    document.addEventListener("swym:collections-loaded", function(){
      swat.initializeActionButtons(".boost-pfs-filter-products");
      window.fetchWishlists()
    })
  });

  // Set new page number on current url maintaining other params
  function buildPaginationUrl(page) {
    var searchParams = new URLSearchParams(window.location.search);
    if (page <= 1) {
      searchParams.delete('page');
    } else {
      searchParams.set('page', page);
    }
    return `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`
  }

  /**
   * Pagination
   */
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;

    // Get page info
    const limit = Utils.stripHtml(Globals.queryParams.limit)

    let viewedProducts = limit
    let currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
    let totalPages = Math.ceil(totalProduct / limit);

    if (!currentPage || isNaN(currentPage) || currentPage < 1) {
      currentPage = 1;
    }

    // Custom Max Page Limit in Metafields
    if (boostPFSThemeConfig.custom.maxPages > 0) {
      totalPages = Math.min(totalPages, boostPFSThemeConfig.custom.maxPages)
      totalProduct = Math.min(totalProduct, totalPages * Utils.stripHtml(Globals.queryParams.limit))
    }

    const collectionCount = document.querySelectorAll('[data-collection-title]')
    collectionCount.forEach((el) => {
      el.textContent = `${totalProduct} Styles`
    })

    const topPagination = document.querySelectorAll('[data-boost-top-pagination]')

    // If it has only one page, clear Pagination
    if (totalPages <= 1) {
      topPagination.forEach((el) => {
        el.innerHTML = ''
      })

      return '';
    }

    if (currentPage === totalPages) {
      viewedProducts = totalProduct
    } else if (currentPage > 1) {
      viewedProducts = currentPage * limit
    }

    const viewedPercentage = (100 * parseFloat(viewedProducts)) / parseFloat(totalProduct)
    const progressWidth = viewedPercentage < 100 ? `${viewedPercentage}%` : '100%'

    // Templates
    let paginationHtml = boostPFSTemplate.paginateHtml
    let paginationTopHtml = boostPFSTemplate.paginateTopHtml

    // Build Previous
    let previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, buildPaginationUrl(currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    let previousTopHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveTopHtml : boostPFSTemplate.previousDisabledTopHtml;
    previousTopHtml = previousTopHtml.replace(/{{itemUrl}}/g, buildPaginationUrl(currentPage - 1));
    previousTopHtml = previousTopHtml.replace(/{{itemPage}}/g, currentPage - 1)
    paginationTopHtml = paginationTopHtml.replace(/{{previous}}/g, previousTopHtml);

    // Build Next
    let nextHtml = (currentPage < totalPages) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, buildPaginationUrl(currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    let nextTopHtml = (currentPage < totalPages) ? boostPFSTemplate.nextActiveTopHtml : boostPFSTemplate.nextDisabledTopHtml;
    nextTopHtml = nextTopHtml.replace(/{{itemUrl}}/g, buildPaginationUrl(currentPage + 1));
    nextTopHtml = nextTopHtml.replace(/{{itemPage}}/g, currentPage + 1)
    paginationTopHtml = paginationTopHtml.replace(/{{next}}/g, nextTopHtml);

    paginationHtml = paginationHtml.replace(/{{viewingLast}}/g, viewedProducts)
    paginationHtml = paginationHtml.replace(/{{totalProduct}}/g, totalProduct)
    paginationHtml = paginationHtml.replace(/{{progress}}/g, progressWidth)

    paginationTopHtml = paginationTopHtml.replace(/{{currentPage}}/g, currentPage)
    paginationTopHtml = paginationTopHtml.replace(/{{totalPage}}/g, totalPages)

    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPages; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPages) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPages) {
      afterCurrentPageArr.push(totalPages);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, buildPaginationUrl(pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

    // Dynamic Elements related to pagination
    topPagination.forEach((el) => {
      el.innerHTML = paginationTopHtml
    })
    window.fetchWishlists()
    return paginationHtml;
  }

  // Override scroll
  ProductPaginationDefault.prototype._onClickEvent = function(event) {
    event.preventDefault();
    Globals.internalClick = true;
    // Get the pagination link
    var pageUrl = jQuery(event.currentTarget).attr('href');
    // Apply filter
    FilterApi.updateParamsFromUrl(pageUrl);
    FilterApi.applyFilter('page');
    // Scroll to top of product list
    const offset = jQuery('.boost-pfs-filter-products').offset().top - jQuery('header').outerHeight() - 125
    jQuery('body,html').animate({
      scrollTop: offset
    }, 600);
  }

  function paginationEvents() {
    jQuery('[data-boost-top-pagination]').on('click', 'a', (e) => {
      e.preventDefault()
      const page = e.currentTarget.dataset.page
      FilterApi.setParam('page', page)
      FilterApi.applyFilter('page')

      const offset = jQuery('.boost-pfs-filter-products').offset().top - jQuery('header').outerHeight() - 125
      jQuery('body,html').animate({
        scrollTop: offset
      }, 600);
    })
  }

  paginationEvents()

  /**
   * Sorting Options
   */
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      const sortingArr = Utils.getSortingList();
      const sortingLabels = boostPFSFilterConfig.label
      if (sortingArr) {
        let paramSort = Utils.stripHtml(Globals.queryParams.sort) || 'manual';
        if (paramSort === 'created-descending') {
          paramSort = 'published-descending'
        }

        // Build content
        let sortingItemsHtml = '';
        for (var k in sortingArr) {
          let selected = ''
          if (paramSort == k) {
            selected = ' selected';
          }

          let label = sortingArr[k]
          if (sortingLabels[`sorting_${k}`]) {
            label = sortingLabels[`sorting_${k}`]
          }

          sortingItemsHtml += `<option value="${k}"${selected}>${label}</option>`;
        }
        const html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
        return html;
      }
    }
    return '';
  };

  ProductSorting.prototype.render = function() {
    jQuery(Selector.topSorting).html(this.compileTemplate());
    var $selectInput = jQ(Selector.topSorting + ' select');
    if ($selectInput.length) {
      if (Globals.queryParams.sort === 'created-descending') {
        $selectInput.val('published-descending');
      } else {
        $selectInput.val(Globals.queryParams.sort);
      }
    }
  }

  /**
   * Results Count
   */
  Filter.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    new ProductPromotion()
  }

  /**
   * Push content down when filters are opened
   * https://boost-pfs-lib-v2-dev-doc.s3.us-west-2.amazonaws.com/components_filter_filter-tree_filter-option-element_filter-collapse.js.html
   */
  FilterCollapse.prototype.afterToggle = function() {
    if (!this.isCollapsed) {
      jQuery('html').addClass('filters--open')
    } else {
      jQuery('html').removeClass('filters--open')
    }
  }

  FilterCollapse.prototype.onClickOutSideHorizontal = function(event) {
    if (!event || !event.target) return;
    var clickedElement = jQ(event.target);
    // Returns if clicking inside the filter tree
    if (clickedElement.closest(Selector.filterTreeHorizontal + ' .' + Class.filterOption).length > 0) {
      return;
    }
    if (clickedElement.closest(Selector.filterTreeHorizontal + ' .' + Class.clearButton).length > 0) {
      return;
    }
    if (clickedElement.closest(Selector.filterTreeHorizontal + ' .' + Class.clearAllButton).length > 0) {
      return;
    }
    this.closeAllHorizontalTabs();
    jQuery('html').removeClass('filters--open')
  }

  /**
   * Mobile Filter Button
   */
  FilterMobileButton.prototype.getTemplate = function (){
    var html = `
      <button type="button" aria-label="Filter By">
        <span class="boost-pfs-filter-tree-mobile-button-label">Filter By</span>
      </button>`;
    return html;
  }

})();
